const numberFormatter = new Intl.NumberFormat('en-US');
const numberFormatterShort = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});
const numberFormatterShortExt = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumSignificantDigits: 3,
});

export function formatNumber(num: number): string {
  return numberFormatter.format(Math.round(num));
}

export function formatNumberShort(num: number): string {
  return numberFormatterShort.format(Math.round(num));
}

export function formatNumberShortExt(num: number): string {
  return numberFormatterShortExt.format(Math.round(num));
}

export function formatLargeNumber(value: string) {
  const num = parseFloat(value);
  const divided = num / 1e9;

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(divided);
}

export function cutText(text: string, limit: number = 50): string {
  if (text.length > limit) return text.slice(0, limit) + '...';
  return text.slice(0, limit);
}

const sec = 1000;
const min = sec * 60;
const hour = min * 60;

export function formatEta(num: number): string {
  let t = num;

  const hours = String(Math.trunc(t / hour)).padStart(2, '0');
  t = t % hour;
  const mins = String(Math.trunc(t / min)).padStart(2, '0');
  t = t % min;
  const secs = String(Math.trunc(t / sec)).padStart(2, '0');
  t = t % sec;
  return `${hours}:${mins}:${secs}`;
}

export const formatWalletAddress = (address: string) =>
  [address.slice(0, 6), '...', address.slice(address.length - 4)].join('');
